module.exports = __webpack_public_path__ + "infocentrum16.jpg?9e4d0e7351708a5ffcf67d4f9a575473";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/infocentrum/infocentrum16.jpg
// module id = 268
// module chunks = 0